import organization from "@/assets/data/organizationConfig.js";
export default {
  data() {
    return {
      timeZone: "",
      orgObj: {},
    };
  },
  // watch: {
  //   orgObj: {
  //     handler(newVal) {
  //       if (newVal?.orgName === "getboarded") {
  //         return (newVal.orgName = "default");
  //       }
  //       if (newVal?.orgColor) {
  //         return this.setOrgColor(newVal.orgColor);
  //       }
  //     },
  //     deep: true,
  //     immediate: true,
  //   },
  // },
  created() {
    this.findOrg();
    this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  },
  methods: {
    findOrg() {
      if (this.$route.query.org) {
        this.orgObj = organization.find((organization) => {
          return organization.orgName === this.$route.query.org;
        });
      } else {
        this.orgObj = {
          orgName: "alex",
          orgColor: "#e82b51",
        };
      }

      this.orgObj = Object.assign(this.orgObj, this.$route.query);
    },
  },
};
